import { StarIcon as StarOutline } from '@heroicons/react/24/outline';
import { StarIcon as StarSolid } from '@heroicons/react/24/solid';
import { useTranslation } from '@/store/languageStore';
import { useFavoriteModules } from '@/hooks/useFavoriteModules';

interface ModuleFavoriteStarProps {
  systemName: string;
  moduleName: string;
  className?: string;
}

export default function ModuleFavoriteStar({
  systemName,
  moduleName,
  className = 'absolute top-3 right-3',
}: ModuleFavoriteStarProps) {
  const { t } = useTranslation();
  const { isFavorite, toggleFavorite } = useFavoriteModules();
  const starred = isFavorite(systemName, moduleName);

  return (
    <button
      type="button"
      aria-label={starred ? t('modules.removeFavorite') : t('modules.addFavorite')}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        void toggleFavorite(systemName, moduleName);
      }}
      className={`${className} p-1 rounded-md text-textTertiary hover:text-amber-500`}
    >
      {starred ? (
        <StarSolid className="w-5 h-5 text-amber-400" />
      ) : (
        <StarOutline className="w-5 h-5" />
      )}
    </button>
  );
}
